module.exports = __webpack_public_path__ + "static/media/info.56acac05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Icon/assets/info.svg
// module id = 589
// module chunks = 0